export default __webpack_public_path__ + "static/a_herz-51a4eff358ad299ca8c73aa2fe081b17.jpg";